import { Floor } from "@pdfking/math"

import type { RandomStream } from "#internal"

// `items` in an order `random` draws, every one once (Fisher–Yates)
export const RandomShuffle = <T>(random: RandomStream, items: Iterable<T>): T[] => {
  const shuffled = [...items]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Floor(random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j]!, shuffled[i]!]
  }
  return shuffled
}
